module.exports = __webpack_public_path__ + "static/media/trofeu.8a930b6a.svg";